module.exports = __webpack_public_path__ + "static/img/developerPlatformLogo.dff174f3.png";